var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Home',{attrs:{"data":_vm.data,"fileName":_vm.fileName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }